<template>
	<div>
		<router-link :to="routerURL" v-if="name">{{ title }}</router-link>
		<NewTabLink :linkURL="scoreURL" :text="title" v-else></NewTabLink>
	</div>
</template>

<script>
import NewTabLink from "../NewTabLink.vue";
export default {
	components: {
		NewTabLink,
	},
	props: {
		title:{
			type: String,
			required: true,
		},
		scoreURL: {
			type: String,
			// required: true,
		},
		name: {
			type: String,

		}
	},
	computed: {
		routerURL() {
			return "/danoni/" + this.name;
		}
	}
}
</script>
